import ProjectTemplate from '../../components/common/ProjectTemplate';
import TowerListActionButtons from '../../components/tower/TowerListActionButtons';
import TowerListContainer from '../../components/tower/TowerListContainer';

const TowerListPage = () => {
    return (
        <ProjectTemplate>
            <TowerListContainer />
            <TowerListActionButtons />
        </ProjectTemplate>
    );
};

export default TowerListPage;
